module.exports = "https://web-assets.ifttt.com/packs/media/platform/Data_icon-7bacd33a.svg";